import React, { useCallback } from 'react'

import { I18n } from '@front/volcanion'

import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'
import { Box, Grid } from '@mui/material'

import Callbacks from './callbacks'
import Form from './Form'
import Header from './Header'
import Row from './Row'

const PoiList = props =>
  <Box sx={{ p: 2 }}>
    <Grid container justifyContent='center'>
      <Grid size={11}>
        <SearchFrame
          model_name={'poi'}
          populate={['type', 'city_polygon']}
          createButtonProps={{
            label: I18n.t('poi.add')
          }}
        >
          <SearchForm
            submitOnMount
            filterToForm={useCallback(Callbacks.filterToFormHandler(), [])}
            formToFilter={useCallback(Callbacks.formToFilterHandler(), [])}
          >
            <FormContent><Form /></FormContent>
          </SearchForm>
          <SearchTable>
            <TableHeader><Header /></TableHeader>
            <TableRow><Row /></TableRow>
          </SearchTable>
        </SearchFrame>

      </Grid>
    </Grid>
  </Box>


export default React.memo(PoiList)
